export default class LoginWrapper extends HTMLElement {

	constructor(){

		super();

        this.loginForm = this.querySelector('#login')
        this.cancelBtn = this.querySelector('#cancelRecoverBtn')
        this.recoverForm = this.querySelector('#recover')
        this.recoverBtn = this.querySelector('#recoverBtn')

		this.init();
	}

	init() {

        this.recoverBtn.addEventListener('click', ()=>{this.recoveryScreen()})
        this.cancelBtn.addEventListener('click', ()=>{this.loginScreen()})
	}

    recoveryScreen() {
        this.recoverForm.classList.remove('hidden')
        this.loginForm.classList.add('hidden')
    }

    loginScreen() {
        this.recoverForm.classList.add('hidden')
        this.loginForm.classList.remove('hidden')
    }

}
